import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { L94Rfil94 } from '../models/models/pages/l94rfil94';

@Injectable({ providedIn: 'root' })
export class L94Rfil94Service {
    private baseUrl = `${environment.baseApiUrl}/l-94-rfil-94`;

    constructor(private http: HttpClient) {}

    /*list(params?: { page?: number; size?: number; sort?: string, filter?: string }): Observable<HttpResponse<L94Rfil94[]>> {
    let httpParams = new HttpParams();
    if (params?.page != null) httpParams = httpParams.set('page', params.page);
    if (params?.size != null) httpParams = httpParams.set('size', params.size);
    if (params?.sort) httpParams = httpParams.set('sort', params.sort);
    if (params?.filter) httpParams = httpParams.set('filter', params.filter);

    return this.http.get<L94Rfil94[]>(this.baseUrl, {
      params: httpParams,
      withCredentials: true,
      observe: 'response'
    });
  }*/

    list(): Observable<L94Rfil94[]> {
        return this.http.get<L94Rfil94[]>(this.baseUrl);
    }

    getL94Rfil94Aggregate(): Observable<L94Rfil94[]> {
        return this.http.get<L94Rfil94[]>(`${this.baseUrl}/aggregate`, { withCredentials: true });
    }

    getL94Rfil94BySigla(sigla: string): Observable<L94Rfil94[]> {
        return this.http.get<L94Rfil94[]>(`${this.baseUrl}/sigla/${sigla}`, { withCredentials: true });
    }

    // GET by id
    get(id: number): Observable<L94Rfil94> {
        return this.http.get<L94Rfil94>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    getL94Rfil94Byid(id: number): Observable<L94Rfil94[]> {
        return this.http.get<L94Rfil94[]>(`${this.baseUrl}/l94/${id}`, { withCredentials: true });
    }

    // CREATE (POST)
    create(payload: Omit<L94Rfil94, 'id'> | Omit<L94Rfil94, 'id'>[]): Observable<L94Rfil94[]> {
        const data = Array.isArray(payload) ? payload : [payload];
        return this.http.post<L94Rfil94[]>(this.baseUrl, data, { withCredentials: true });
    }

    update(entity: L94Rfil94): Observable<L94Rfil94> {
        return this.http.put<L94Rfil94>(`${this.baseUrl}/${entity.id}`, entity, { withCredentials: true });
    }

    // PATCH parziale (solo i campi che cambi)
    partialUpdate(id: number, patch: Partial<L94Rfil94>): Observable<L94Rfil94> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/merge-patch+json' });
        return this.http.patch<L94Rfil94>(`${this.baseUrl}/${id}`, patch, {
            headers,
            withCredentials: true
        });
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    findOne(id: number) {
        return this.http.get<L94Rfil94>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }
}
